const initProAtc = (root = document) => {
  for (const wrapper of root.querySelectorAll('[data-pro-atc]')) {
    const form = wrapper.querySelector('form');
    if (!form || form.dataset.proAtcBound === 'true') continue;
    form.dataset.proAtcBound = 'true';
    const submit = form.querySelector('[data-pro-atc-submit]');
    if (!submit || submit.dataset.useAjax !== 'true') continue;
    const skipCart = wrapper.dataset.skipCart === 'true';

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      const idInput = form.querySelector('[data-pro-variant-id]');
      const variantId = idInput?.value;
      if (!variantId) return;

      submit.disabled = true;
      submit.classList.add('loading');
      const spinner = submit.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
        });
        if (!response.ok) throw new Error('Cart add failed');
        if (skipCart) {
          window.location.href = '/checkout';
        } else {
          if (window.theme && window.theme.miniCart) {
            window.theme.miniCart.updateElements();
            window.theme.miniCart.generateCart();

            // Wait for cart drawer ajax to finish
            await new Promise((resolve) => {
              if (window.jQuery) {
                let resolved = false;
                window.jQuery(document).one('ajaxStop', () => {
                  if (!resolved) {
                    resolved = true;
                    resolve();
                  }
                });
                setTimeout(() => {
                  if (!resolved) {
                    resolved = true;
                    resolve();
                  }
                }, 2000);
              } else {
                setTimeout(resolve, 800);
              }
            });
          } else {
            window.location.href = '/cart';
          }
        }
      } catch (err) {
        console.error(err);
        form.submit();
      } finally {
        submit.disabled = false;
        submit.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
      }
    });
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initProAtc());
} else {
  initProAtc();
}
document.addEventListener('shopify:section:load', (event) => initProAtc(event.target));
